/*
 * @Description: 路由
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2024-02-26 14:17:04
 * @LastEditors: YGQ
 * @LastEditTime: 2024-12-06 16:16:08
 */
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: "/", redirect: "/zh-CN", },
  { path: "/join", redirect: '/zh-CN/join', },
  { path: "/about", redirect: '/zh-CN/about', },
  { path: "/zh-CN", component: () => import('@/views/home/'), },
  { path: "/zh-CN/about", component: () => import('@/views/about/'), },
  { path: "/zh-CN/join", component: () => import('@/views/join/'), },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 每次路由切换时滚动到顶部
    return { top: 0 };
  },
})

export default router
